module.exports = __webpack_public_path__ + "img/wild_comming.363ae348.png";